/**
 * The AI assistant's contract: one chat request, and the stored sessions
 * and messages behind it (chat_sessions / chat_messages,
 * apps/api/sql/2026-09-28-chat-history.sql).
 *
 * The SERVER holds the conversation. A request that names a session gets
 * its history from the database; anything the client sends as `history`
 * is ignored. `history` survives only for old clients that send no
 * sessionId - they are answered statelessly and nothing is stored.
 */
/**
 * A session's stored mode. Since the all-in-one chat (CHATBOT_DESIGN.md
 * section 15) every new session is 'general' and one chat answers both task
 * and lottery questions; 'lottery' remains only on sessions made before.
 */
export const ChatMode = {
    GENERAL: 'general',
    /** Old Lottery analyst sessions - still readable and continued like any other. */
    LOTTERY: 'lottery',
};
// ------------------------------------------------ Lottery analyst (Phase 8) --
/** How the Lottery analyst answers (docs/lottery/CHATBOT_DESIGN.md 3.2). */
export const ChatPersona = {
    ANALYST: 'analyst',
    MARKETING: 'marketing',
    ADVISOR: 'advisor',
};
/**
 * The web widget's waiting label (CHATBOT_DESIGN.md 17.5, review D): an
 * advice-shaped question shows "Preparing advice…" while it waits. A label
 * only - the server's intents decide the reply.
 */
export const ADVICE_LIKELY = /\b(sugg?es\w*|sugest\w*|recomm?end\w*|reccom\w*|advi[cs]e|ideas?|tips|strategy|what should (i|we)|how (can|could|do|should) (we|i) (improve|increase|boost|grow|reduce|lower|bring|sell more)|should i worry|shud i worry|worr(y|ied)|brief me|briefing|what to tell|wat to tell|draft|priorit\w*|focus on|needs? attention|(trend|pace) continues|on track|explain)\b/i;
export const pendingLabel = (question) => (question && ADVICE_LIKELY.test(question) ? 'Preparing advice…' : 'Working on it…');
//# sourceMappingURL=chat.js.map